import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { SwiperSlide, Swiper } from 'swiper/react';
import "swiper/css";
import "./categoryList.scss"
import CategoryCard from '../category-card/CategoryCard';

const CategoryList = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const getList = async () => {
      const response = await axios.get(`https://www.themealdb.com/api/json/v1/1/categories.php`);
      setItems(response.data.categories.slice(0, 9));
      // console.log(response.data.categories);
    }
    getList();
  }, []);
  return (
    <div className="category-list">
      <Swiper
        grabCursor={true}
        spaceBetween={10}
        slidesPerView={'auto'}

      >
        {
          items.map((item, index) => (
            <SwiperSlide key={index}>
              {/* <img src={item.strCategoryThumb} alt="" /> */}
              <CategoryCard title={item.strCategory} image={item.strCategoryThumb} id={item.idCategory} />
            </SwiperSlide>
          ))
        }
      </Swiper>
    </div>
  )
}

export default CategoryList